import React, { useState, useEffect } from 'react';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import Snackbar from '@mui/material/Snackbar';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { API } from '../../../API';
import EditIcon from '@mui/icons-material/Edit';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Alert, Box, FormControl, Input, InputLabel, MenuItem, Paper, Select } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';

function Row(props) {
  const { row, payrollTaxes, snackbar, setSnackbar } = props;
  const [open, setOpen] = useState(false);
  const [isEditable, setIsEditable] = useState(false);

  const [state, setState] = useState(row?.payment_setting_admin || {
    payment_period: 0,
    campuses: []
  });
  const handleEditClick = () => {
    setIsEditable(true);
    setOpen(true);
  }
  const handlePercentChange = (e, id) => {
    const newCampuses = [...state.campuses];
    const index = state.campuses.findIndex(item => item?.campus_id === id)
    if (index === -1) {
      newCampuses.push({
        campus_id: id,
        discount: e?.target?.value || "",
        expiration_date: "",
      })
    } else {
      newCampuses[index] = {
        ...state.campuses?.[index],
        discount: e?.target?.value || "",
      }
    }
    setState(preState => ({ ...preState, campuses: newCampuses }))
  }

  const handleExpirationDateChange = (e, id) => {
    const newCampuses = [...state.campuses];
    const index = state.campuses.findIndex(item => item?.campus_id === id)
    if (index === -1) {
      newCampuses.push({
        campus_id: id,
        percent_id: "",
        percent: 0,
        expiration_date: e.format('YYYY/MM/DD'),
      })
    } else {
      newCampuses[index] = {
        ...state.campuses?.[index],
        expiration_date: e.format('YYYY/MM/DD'),
      }
    }
    setState(preState => ({ ...preState, campuses: newCampuses }))
  }

  const handleSubmit = async (id) => {
    try {
      await API.updateInvoiceSetting(id, state).then((result) => {
        setIsEditable(false);
        setSnackbar({ children: 'Setting successfully saved', severity: 'success' });
      });
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.institution_name}
        </TableCell>
        <TableCell align="right">{row?.full_name}</TableCell>
        <TableCell>
          {
            isEditable ?
              <Input value={state.payment_period} onChange={(e) => setState(preState => ({ ...preState, payment_period: e.target.value }))} type='number'></Input> :
              row?.payment_setting_admin?.payment_period
          }
        </TableCell>
        <TableCell align="right">
          {
            isEditable ?
              <IconButton onClick={() => handleSubmit(row?.institution?._id)}>
                <SaveIcon />
              </IconButton>
              : <IconButton onClick={() => handleEditClick()}>
                <EditIcon />
              </IconButton>
          }
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Campuses
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Campus Location</TableCell>
                    <TableCell>Discount</TableCell>
                    <TableCell>Expiration Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.campuses?.map((campus) => (
                    <TableRow key={campus._id}>
                      <TableCell component="th" scope="row">
                        {campus?.campus_shortname} {campus?.suburb} {campus?.state}
                      </TableCell>
                      <TableCell>
                        {
                          isEditable ?
                          <Input value={state?.campuses?.find(item => item?.campus_id == campus._id)?.discount} onChange={(e) => handlePercentChange(e, campus?._id)} type='number' />
                            : state?.campuses?.find(item => item?.campus_id == campus._id)?.discount
                        }
                      </TableCell>
                      <TableCell>
                        {
                          isEditable ?
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                  label="Expiration Date"
                                  format='DD/MM/YYYY'
                                  value={dayjs(state?.campuses?.find(item => item?.campus_id === campus?._id)?.expiration_date)}
                                  onChange={(e) => handleExpirationDateChange(e, campus?._id)}
                                />
                              </DemoContainer>
                            </LocalizationProvider> :
                            state?.campuses?.find(item => item?.campus_id === campus?._id)?.expiration_date ?
                              dayjs(state?.campuses?.find(item => item?.campus_id === campus?._id)?.expiration_date).format('DD/MM/YYYY') :
                              ''
                        }
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function InvoiceSettingTable(props) {
  const payrollTaxes = props.data;
  const [customers, setCustomers] = useState([]);
  const [customerSearch, setCustomerSearch] = useState([]);
  const [snackbar, setSnackbar] = useState(null);

  const handleSearch = (e) => {
    let searchItem = e.target.value.toLowerCase();

    if (searchItem.length > 0) {
      if (customers.length > 0) {
        let filteredData = customers.filter((c) =>
          c.full_name === undefined ||
            c.institution_name === undefined
            ? false
            : filterCriteria(c).includes(searchItem)
        );
        setCustomerSearch(filteredData);
      }
    } else {
      setCustomerSearch(customers);
    }
  }

  const filterCriteria = (c) => {
    let results = "";
    if (c.full_name) results += c.full_name;
    if (c.institution_name) results += c.institution_name;

    if (c.institution) {
      if (c.institution.inst_shortname)
        results += c.institution.inst_shortname;
      if (c.institution.institution_name)
        results += c.institution.institution_name;
    }

    return results.toLowerCase();
  };
  const handleCloseSnackbar = () => setSnackbar(null);

  useEffect(() => {
    API.fetchCustomersPagination().then((result) => {
      const data = result.data.data.map(inst => {
        return {
          id: inst._id,
          _id: inst._id,
          institution: inst.institution_id,
          institution_name: inst.institution_name ? inst.institution_name : (inst?.institution_id?.institution_name || ""),
          full_name: inst.first_name + inst.last_name,
          campuses: inst?.institution_id?.campuses_detail,
          payment_setting_admin: inst?.institution_id?.payment_setting_admin,
          payrollTaxes
        }
      })
      setCustomers(data);
      setCustomerSearch(data);
    });
  }, []);
  return (
    <TableContainer sx={{ height: 400, width: '100%' }} component={Paper}>
      <TextField disabled={customers.length === 0} onChange={handleSearch} sx={{ m: 2 }} id="outlined-search" label="Search by Keyword" type="search" />
      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
          autoHideDuration={6000}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell component="th">Institution Name</TableCell>
            <TableCell component="th" align="right">Contact Name</TableCell>
            <TableCell component="th">Payment Period</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {customerSearch.map((row) => (
            <Row key={row._id} row={row} payrollTaxes={payrollTaxes} snackbar={snackbar} setSnackbar={setSnackbar} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}